// Suggestions API helpers

import { API_CONFIG } from '../../config/api';

export interface SuggestionData {
  title: string;
  description: string;
}

export interface SuggestionResponse {
  id: string;
  title: string;
  description: string;
  createdBy: {
    id: string;
    firstName?: string;
    lastName?: string;
    preferredName?: string;
    email: string;
  };
  createdAt: string;
  updatedAt: string;
}

export interface AdminSuggestionsResponse {
  success: boolean;
  data: {
    suggestions: SuggestionResponse[];
    pagination: {
      currentPage: number;
      totalPages: number;
      totalSuggestions: number;
      hasNext: boolean;
      hasPrev: boolean;
    };
  };
}

export interface CreateSuggestionResponse {
  success: boolean;
  message: string;
  data: SuggestionResponse;
}

/**
 * Create a new suggestion
 */
export const createSuggestion = async (
  token: string,
  suggestionData: SuggestionData
): Promise<CreateSuggestionResponse> => {
  try {
    const response = await fetch(API_CONFIG.ENDPOINTS.SUGGESTIONS, {
      method: 'POST',
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(suggestionData)
    });

    const data = await response.json();

    if (!response.ok) {
      throw new Error(data.message || 'Failed to submit suggestion');
    }

    return data;
  } catch (error) {

    throw error;
  }
};

/**
 * Get suggestions for admin review
 */
export const getAdminSuggestions = async (
  token: string,
  page = 1,
  limit = 10,
  search = ''
): Promise<AdminSuggestionsResponse> => {
  try {
    const params = new URLSearchParams({
      page: page.toString(),
      limit: limit.toString()
    });

    if (search) {
      params.append('search', search);
    }

    const response = await fetch(`${API_CONFIG.ENDPOINTS.SUGGESTIONS_ADMIN}?${params}`, {
      method: 'GET',
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json'
      }
    });

    const data = await response.json();

    if (!response.ok) {
      throw new Error(data.message || 'Failed to fetch suggestions');
    }

    return data;
  } catch (error) {

    throw error;
  }
};

/**
 * Helper function to get auth token from localStorage
 */
export const getAuthToken = (): string | null => {
  return localStorage.getItem('token');
};
